import type { PluginOption } from 'vite';

import {
  getBlocksWidgetHMRTemplate,
  BLOCKS_WIDGET_HMR_RE,
} from './blocks-components.js';
import {
  getCustomElementHMRTemplate,
  CUSTOM_ELEMENT_HMR_RE,
} from './custom-element.js';
import {
  getComponentHMRTemplate,
  COMPONENT_HMR_RE,
} from './react-component.js';
import {
  SITE_COMPONENT_HMR_PARAMETER_RE,
  getSiteComponentSdkHMRTemplate,
  SITE_COMPONENT_SDK_HMR_PARAMETER_RE,
} from './site-component.js';

export function hmr(): PluginOption {
  let root: string;

  return {
    name: 'wix:hmr',
    apply: 'serve',
    configResolved(config) {
      root = config.root;
    },
    load(id) {
      if (COMPONENT_HMR_RE.test(id)) {
        return {
          code: getComponentHMRTemplate(id, root),
        };
      }

      if (BLOCKS_WIDGET_HMR_RE.test(id)) {
        return {
          code: getBlocksWidgetHMRTemplate(id, root),
        };
      }

      if (CUSTOM_ELEMENT_HMR_RE.test(id)) {
        return {
          code: getCustomElementHMRTemplate(id, root),
        };
      }

      return null;
    },
  };
}

export function hmrSiteComponents(): PluginOption {
  let root: string;

  return {
    name: 'wix:hmr',
    apply: 'serve',
    configResolved(config) {
      root = config.root;
    },
    load(id) {
      if (SITE_COMPONENT_HMR_PARAMETER_RE.test(id)) {
        return {
          code: getComponentHMRTemplate(
            id.replace(SITE_COMPONENT_HMR_PARAMETER_RE, '').replace(root, ''),
            root
          ),
        };
      }

      if (SITE_COMPONENT_SDK_HMR_PARAMETER_RE.test(id)) {
        return {
          code: getSiteComponentSdkHMRTemplate(id, root),
        };
      }

      return null;
    },
  };
}

export { getBlocksPathWithHMR } from './blocks-components.js';
export { getCustomElementPathWithHMR } from './custom-element.js';
export { getComponentPathWithHMR } from './react-component.js';
export {
  getSiteComponentSdkPathWithHMR,
  getSiteComponentPathWithHMR,
} from './site-component.js';
